module.exports = __webpack_public_path__ + "img/icon_firmware_active.7e3aed95.svg";